import { AdminChangePassword, AdminNotifications, AdminProfile } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for admin-related pages.
 * @returns {Array} An array of route objects.
 * @function generateAdminRoutes
 */
export default function route() {
  return [
    {
      path: adminRouteMap.ADMIN_PROFILE.path,
      name: "Profile",
      key: adminRouteMap.ADMIN_PROFILE.path,
      private: true,  // Requires authentication
      belongsToSidebar: false,  // Does not appear in the sidebar
      element: <AdminProfile />,  // Component to render for this route
    },
    {
      path: adminRouteMap.ADMIN_CHANGE_PASSWORD.path,
      name: "Change Password",
      key: adminRouteMap.ADMIN_CHANGE_PASSWORD.path,
      private: true,  // Requires authentication
      belongsToSidebar: false,  // Does not appear in the sidebar
      element: <AdminChangePassword />,  // Component to render for this route
    },
    {
      path: adminRouteMap.ADMIN_NOTIFICATIONS.path,
      name: "Notifications",
      key: adminRouteMap.ADMIN_NOTIFICATIONS.path,
      private: true,  // Requires authentication
      belongsToSidebar: false,  // Does not appear in the sidebar
      element: <AdminNotifications />,  // Component to render for this route
    },
  ];
}
